import { API_BASE } from "../apiConfig";

const CACHE_KEY = "innervoice_public_settings";
const CACHE_TTL = 5 * 60 * 1000;

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (Date.now() - parsed.timestamp > CACHE_TTL) return null;
    return parsed.data;
  } catch {
    return null;
  }
}

function writeCache(data) {
  try {
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ data, timestamp: Date.now() })
    );
  } catch {
    // ignore
  }
}

export async function fetchPublicSettings() {
  const cached = readCache();
  if (cached) return cached;
  const res = await fetch(`${API_BASE}/api/public/settings`);
  if (!res.ok) return null;
  const data = await res.json().catch(() => null);
  if (data) writeCache(data);
  return data;
}
